import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Normalize markdown (remove accidental code fences)
 */
function normalizeMarkdown(content) {
  if (!content) return '';
  return content
    .replace(/^```(?:markdown)?/i, '')
    .replace(/```$/i, '')
    .trim();
}

/**
 * Custom renderers for PROFESSIONAL layout
 */
const components = {
  h1: ({ children }) => (
    <h1 className="text-3xl font-bold text-white mt-10 mb-6 border-b border-white/10 pb-3">
      {children}
    </h1>
  ),
  h2: ({ children }) => (
    <h2 className="text-2xl font-semibold text-accent-teal mt-8 mb-4">
      {children}
    </h2>
  ),
  h3: ({ children }) => (
    <h3 className="text-lg font-semibold text-white mt-6 mb-3">
      {children}
    </h3>
  ),
  p: ({ children }) => (
    <p className="text-neutral-silver leading-relaxed mb-4">
      {children}
    </p>
  ),
  ul: ({ children }) => (
    <ul className="list-disc pl-6 mb-6 space-y-2">
      {children}
    </ul>
  ),
  li: ({ children }) => (
    <li className="text-neutral-silver">
      {children}
    </li>
  ),
  strong: ({ children }) => (
    <strong className="text-white font-semibold">
      {children}
    </strong>
  ),
  hr: () => (
    <hr className="my-10 border-white/10" />
  ),
};

const MarkdownRenderer = ({ content }) => {
  const safeContent = normalizeMarkdown(content);

  return (
    <div className="max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={components}
      >
        {safeContent}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
